import type {
    BaseColumnCategory,
    ColumnCategoryConfig,
} from "app/pages/sales-intelligence/common-components/column-picker";
import type { AppColumnCategory } from "app/pages/sales-intelligence/modules/apps-search/types/rows";

export const createAppsColumnCategoriesConfig = (
    categories: readonly AppColumnCategory[] | null | undefined,
): readonly ColumnCategoryConfig<AppColumnCategory | BaseColumnCategory>[] => [
    {
        labelKey: "si.find_apps.column-picker.category.all",
        name: "all",
    },
    ...(categories ?? []).map((c) => ({
        labelKey: `si.find_apps.column-picker.category.${c}`,
        name: c,
    })),
];
